export const DEV = 'dev';
export const PROD = 'prod';
const apiIDForDev = '50tzm35e9i';
const apiIDForProd = '1gdqur0cte';
const websocketDevApiUrl = `${apiIDForDev}.execute-api.us-west-2.amazonaws.com/dev`;

const ApiUrlToWebSocketApiID = {
  'https://app-api-dev.joinportal.com': websocketDevApiUrl,
  'https://app-api.joinportal.com': `${apiIDForProd}.execute-api.us-west-2.amazonaws.com/production`,
};

type ApiUrlToWebSocketApiID = typeof ApiUrlToWebSocketApiID;

type ApiUrlToWebSocketApiIDKeys = keyof ApiUrlToWebSocketApiID;

/**
 * Given the core api url determine which websocket api id to use
 * when the input core api url does not match any of the keys in the
 * ApiUrlToWebSocketApiID object use the dev websocket api id
 * @param apiUrl the api url for core api
 * @param userId the current userId to connect to the websocket
 * @returns websocket url to connect to
 */
export const GetWebSocketUrl = (
  apiUrl: ApiUrlToWebSocketApiIDKeys,
  userId: string,
) => {
  const websocketApiURL = ApiUrlToWebSocketApiID[apiUrl] || websocketDevApiUrl;
  return `wss://${websocketApiURL}?userID=${userId}`;
};
